function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js/instance/for-each";
import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/reduce";
import _flatInstanceProperty from "@babel/runtime-corejs3/core-js/instance/flat";
import _Object$entries from "@babel/runtime-corejs3/core-js/object/entries";
import React from "react";
export var withClasses = function withClasses(defaultCssModule) {
  var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    _ref2$propName = _ref2.propName,
    propName = _ref2$propName === void 0 ? 'classes' : _ref2$propName;
  var decorator = function decorator(Component) {
    var ComponentWithCSSModule = function ComponentWithCSSModule(_ref) {
      var givenClasses = _ref[propName],
        props = _objectWithoutProperties(_ref, [propName].map(_toPropertyKey));
      var classes = givenClasses || defaultCssModule;
      var finalCssModules = classes;
      if (typeof classes === 'function') {
        finalCssModules = classes(defaultCssModule);
      }
      var newProps = _objectSpread(_objectSpread({}, props), {}, _defineProperty({}, propName, finalCssModules));
      return /*#__PURE__*/React.createElement(Component, newProps);
    };
    ComponentWithCSSModule.displayName = "WithCSSModule(".concat(Component.displayName || Component.name || 'Unknown', ")");
    return ComponentWithCSSModule;
  };
  return decorator;
};
var replaceClassNameReducer = function replaceClassNameReducer(_, newClassName) {
  return newClassName;
};
var combineClassNameReducer = function combineClassNameReducer() {
  var previousClassName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var newClassName = arguments.length > 1 ? arguments[1] : undefined;
  return "".concat(previousClassName, " ").concat(newClassName);
};
var createNewCssModule = function createNewCssModule(defaultCssModule, newCssModule, classNameReducer) {
  var _context;
  var finalCssModule = _objectSpread({}, defaultCssModule);
  _forEachInstanceProperty(_context = _Object$keys(newCssModule)).call(_context, function (classIdentifier) {
    var previousClassName = finalCssModule[classIdentifier];
    var newClassName = newCssModule[classIdentifier];
    finalCssModule[classIdentifier] = classNameReducer(previousClassName, newClassName);
  });
  return finalCssModule;
};
export var compose = function compose(newCssModule) {
  var composeMapper = function composeMapper(defaultCssModule) {
    return createNewCssModule(defaultCssModule, newCssModule, combineClassNameReducer);
  };
  return composeMapper;
};
export var replace = function replace(newCssModule) {
  var replaceMapper = function replaceMapper(defaultCssModule) {
    return createNewCssModule(defaultCssModule, newCssModule, replaceClassNameReducer);
  };
  return replaceMapper;
};
export var useClasses = function useClasses() {
  for (var _len = arguments.length, cssModules = new Array(_len), _key = 0; _key < _len; _key++) {
    cssModules[_key] = arguments[_key];
  }
  if (cssModules[0] === undefined) {
    throw new Error('Base css module is undefined. This is not allowed');
  }
  return React.useMemo(function () {
    var normalizedCssModuleList = _filterInstanceProperty(cssModules).call(cssModules, function (el) {
      return el !== undefined;
    });
    return _reduceInstanceProperty(normalizedCssModuleList).call(normalizedCssModuleList, function (last, next) {
      if (typeof next === 'function') {
        return next(last);
      }
      return next;
    });
  }, cssModules);
};
export var useClassesMapper = function useClassesMapper(mapper) {
  for (var _len2 = arguments.length, cssModules = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    cssModules[_key2 - 1] = arguments[_key2];
  }
  if (typeof mapper !== 'function') {
    throw new Error("Expected first argument to be a mapper function. This should be the result of calling \n#compose or #replace");
  }
  return React.useMemo(function () {
    var normalizedCssModuleList = _filterInstanceProperty(cssModules).call(cssModules, function (el) {
      return el !== undefined;
    });
    return _reduceInstanceProperty(normalizedCssModuleList).call(normalizedCssModuleList, function (lastMapper, next) {
      return function (defaultCssModule) {
        if (typeof next === 'function') {
          return next(lastMapper(defaultCssModule));
        }
        return next;
      };
    }, mapper);
  }, [mapper].concat(cssModules));
};
export var useClassesCompose = function useClassesCompose(newClasses) {
  var _context2;
  return React.useCallback(compose(newClasses), _flatInstanceProperty(_context2 = _Object$entries(newClasses)).call(_context2));
};